// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"2947974f","488":"268a746f","995":"e66f161f"}[chunkId] + ".chunk.js";
};